
<div class="d-inline-flex align-items-center flex-wrap">
  <!-- generic search input -->
    <search-fields *ngIf="showSearchInput"
                   [searchInputStates]="searchInputStates"
                   [searchKeys]="searchKeys"
                   [order]="order"
                   [searchByMultipleKeys]="searchByMultipleKeys"
                   (searchInputChange)="searchInputChange.emit($event)"
    ></search-fields>

  <!-- predefined search states -->
  <ng-container *ngIf="showSearchStates">
    <ng-container *ngFor="let state of states; let i=index">
      <ng-container *ngIf="!state?.locked"  >

        <span *ngIf="!state.type || state.type==='list'" style="height: fit-content;"
          class="{{inputContainerClass}} {{animation}}" [style.--order]="order+i">
          <span (click)="labelClick.emit(state)" class="d-inline-block m-1 ps-2 text-nowrap">
            {{state.name ?? state.key | camelToTitleCase | readDotProperty}}
          </span>

          <ng-container *ngFor="let value of state.values; let j=index" >
            <span (click)="change.emit({state, value})" style="min-width:30px"
                [ngClass]="{'bg-gradient-full border-accent_':state?.value === value}"
              class="{{listStateValueClass}} {{'scale-up'}}" [style.--order]="order+i+(j/2)">
              <span [ngClass]="{'faded':state?.value !== value}"> {{ value }} </span>
            </span>
          </ng-container>
        </span>

        <span *ngIf="state.type | valueIncludes : ['select','radio','toggle','checkbox','date']"
          style="height: fit-content;" class="{{animation}} d-inline-block" [style.--order]="order+i" >
          <data-input
            [type]="[state.type]"
            [showCancel]="true"
            [active]="!!state.value"
            [label]="state.name ?? state.key | camelToTitleCase"
            [toolTip]="'Filter by' + (state.key | camelToTitleCase | readDotProperty)"
            labelToolTip=""
            [order]="order+i"
            [multiple]="false"
            maxWidth="200px"
            suffixIcon="cirle"
            [options]="state?.values ?? []"
            [value]="state.value"
            (change)="onChange(state,$event)"
          ></data-input>
          <!-- (labelClick)="change.emit({state, value:undefined})" -->
        </span>

        <!--date Range-->
        <date-filter *ngIf="state.type=='dateRange'"
          [order]="5.5"
          [active]="!!state.value"
          [label]="state.name ?? (state.key | camelToTitleCase | readDotProperty)"
          icon="search"
          iconClass="icon-small text-primary top-2"
          [dateRange]="true"
          [date]="state.value?.[0]"
          [endDate]="state.value?.[1]"
          (cancel)="change.emit({state,value:undefined})"
          (startEndDateChange)="change.emit({state,value:$event})"
        ></date-filter>

      </ng-container>
    </ng-container>
  </ng-container>

  <!-- clear predifined search states -->
  <data-label
    *ngIf="hasActiveStates()"
    [order]="order+2"
    icon="close"
    toolTip=""
    iconClass="text-danger"
    (click)="clearSearchStates.emit(true)"
  ></data-label>
</div>

